
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M8 15.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM8 2a6 6 0 00-4.123 10.36 3.75 3.75 0 013.373-2.11h1.875c1.382 0 2.57.83 3.091 2.019A6 6 0 008 2zm2.957 11.222a1.876 1.876 0 00-1.832-1.472H7.25c-.986 0-1.823.634-2.128 1.516A5.973 5.973 0 008 14a5.973 5.973 0 002.957-.778zM8 9.5a3 3 0 110-6 3 3 0 010 6zM8 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"}})])
          )
        }
      }
    